module.exports = __webpack_public_path__ + "img/c05_unitclinicus_Normal_ua.9e1d227c.webp";